import { userApi } from '../../../services/userApi/UserApi';

export function Logout() {
  userApi.logout();
  return null;
}
